// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__gAIss","hasImage":"Breadcrumbs_hasImage__BPPv4","content":"Breadcrumbs_content__9pWF2","background":"Breadcrumbs_background__rLC9U"};